export default __webpack_public_path__ + "static/O0025-e532cb332a6923373e78658a642cd22d.png";